import { TreasuryOfferBaseEntity } from '@genial/services';
import type { V1GetAllTreasuriesWithdrawRequest } from '@genial/services/dist/apis';
import {
  ResponsesTreasuryMarketResponse,
  RiskResponseFilter,
  type ResponsesTreasuryWithdrawItemResponse,
} from '@genial/services/dist/models';
import { atom } from 'recoil';

import { applicationRangeDefault, daysRangeDefault } from '../../../pages/NewApplication/Filter';
import {
  directTreasuryOperationTypeInitialTab,
  pagination,
  sortItemsDirectTreasury,
} from '../constants';
import {
  DirectTreasuryOffersParams,
  DirectTreasuryOffersBySearchTerm,
  DirectTreasuryOffersByFilterParams,
  type DirectTreasuryRescueOffersBySearchTerm,
} from '../types';

export const directTreasuryOffersAllState = atom({
  key: 'directTreasuryOffersAllState',
  default: [] as TreasuryOfferBaseEntity[],
});

export const directTreasuryOffersByFilterParamsState = atom({
  key: 'directTreasuryOffersByFilterParamsState',
  default: {
    ...pagination,
    sortItems: sortItemsDirectTreasury,
    applicationMaximumAmount: applicationRangeDefault.max,
    applicationMinimumAmount: applicationRangeDefault.min,
    minimumDaysToRedemption: daysRangeDefault.min,
    maximumDaysToRedemption: daysRangeDefault.max,
  } as DirectTreasuryOffersByFilterParams,
});

export const directTreasuryOffersParamsState = atom({
  key: 'directTreasuryOffersParamsState',
  default: {
    ...pagination,
  } as DirectTreasuryOffersParams,
});

export const directTreasuryDetailSelectedState = atom<TreasuryOfferBaseEntity>({
  key: 'directTreasuryDetailSelectedState',
  default: undefined,
});

export const directTreasuryMarketStatusState = atom({
  key: 'directTreasuryMarketStatusState',
  default: {} as ResponsesTreasuryMarketResponse,
});

export const directTreasuryOffersBySearchTermParamsState = atom({
  key: 'directTreasuryOffersBySearchTermParamsState',
  default: {
    ...pagination,
    sortItems: sortItemsDirectTreasury,
    applicationMaximumAmount: applicationRangeDefault.max,
    applicationMinimumAmount: applicationRangeDefault.min,
    minimumDaysToRedemption: daysRangeDefault.min,
    maximumDaysToRedemption: daysRangeDefault.max,
    skipEndpointCall: true,
  } as DirectTreasuryOffersBySearchTerm,
});

export const directTreasuryOffersBySearchTermState = atom({
  key: 'directTreasuryOffersBySearchTermState',
  default: [] as TreasuryOfferBaseEntity[],
});

export const directTreasuryRisksFilterState = atom({
  key: 'directTreasuryRisksFilterState',
  default: { data: [] as RiskResponseFilter[] },
});

export const directTreasuryIndexerFilterState = atom({
  key: 'directTreasuryIndexerFilterState',
  default: { data: [] as RiskResponseFilter[] },
});

export const directTreasuryOffersOperationTypeState = atom({
  key: 'directTreasuryOffersOperationTypeState',
  default: directTreasuryOperationTypeInitialTab,
});

export const directTreasuryRescueOffersAllState = atom({
  key: 'directTreasuryRescueOffersAllState',
  default: [] as ResponsesTreasuryWithdrawItemResponse[],
});

export const directTreasuryRescueOffersParamsState = atom({
  key: 'directTreasuryRescueOffersParamsState',
  default: {
    ...pagination,
  } as V1GetAllTreasuriesWithdrawRequest,
});

export const directTreasuryRescueOffersBySearchTermParamsState = atom({
  key: 'directTreasuryRescueOffersBySearchTermParamsState',
  default: {
    ...pagination,
    skipEndpointCall: true,
  } as DirectTreasuryRescueOffersBySearchTerm,
});

export const directTreasuryRescueOffersBySearchTermState = atom({
  key: 'directTreasuryRescueOffersBySearchTermState',
  default: [] as ResponsesTreasuryWithdrawItemResponse[],
});
